import actions from "./actions";
import {setErrorReducer, setRequestReducer, setSuccessReducer} from "../helper";
import arrayMove from "array-move";

const initState = {
    readOrderListState: false,
    deleteOrderState: false,
    updateOrderState: false,

    readCategoryListState: false,
    createCategoryState: false,
    readCategoryState: false,
    updateCategoryState: false,
    updateCategoryFeaturedState: false,
    updateCategoryHiddenState: false,
    updateCategoryPositionState: false,
    deleteCategoryState: false,
    readPageListState: false,
    createPageState: false,
    readPageState: false,
    updatePageState: false,
    deletePageState: false,

    readSettingsState: false,
    updateSettingsState: false,

    // Coupons
    readCouponListState: false,
    createCouponState: false,
    readCouponState: false,
    updateCouponState: false,
    deleteCouponState: false,

    orders: [],
    order: {},
    categories: [],
    category: {},
    coupons: [],
    coupon: {},
    settings: {},
    pagination: {
        total: null,
        current: null,
        pageSize: null,
    },
    pages: [],
    page: {},

    createCategoryResult: null,
    createPageResult: null,
    createCouponResult: null,
    selectedItems: [], // { product_id, is_featured, is_hidden }
};

let selectedItems, idx;
export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.STORE_CP_READ_ORDERS_REQUEST:
            return setRequestReducer(state, 'readOrderListState');
        case actions.STORE_CP_READ_ORDERS_SUCCESS:
            return setSuccessReducer(state, 'readOrderListState', {
                orders: action.orders,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });
        case actions.STORE_CP_READ_ORDERS_ERROR:
            return setErrorReducer(state, 'readOrderListState');

        case actions.STORE_CP_DELETE_ORDER_REQUEST:
            return setRequestReducer(state, 'deleteOrderState');
        case actions.STORE_CP_DELETE_ORDER_SUCCESS:
            return setSuccessReducer(state, 'deleteOrderState', {});
        case actions.STORE_CP_DELETE_ORDER_ERROR:
            return setErrorReducer(state, 'deleteOrderState');
        case actions.STORE_CP_UPDATE_ORDER_REQUEST:
            return setRequestReducer(state, 'updateOrderState');
        case actions.STORE_CP_UPDATE_ORDER_SUCCESS:
            return setSuccessReducer(state, 'updateOrderState', {});
        case actions.STORE_CP_UPDATE_ORDER_ERROR:
            return setErrorReducer(state, 'updateOrderState');

        case actions.STORE_CP_READ_CATEGORIES_REQUEST:
            return setRequestReducer(state, 'readCategoryListState');
        case actions.STORE_CP_READ_CATEGORIES_SUCCESS:
            return setSuccessReducer(state, 'readCategoryListState', {
                categories: action.categories,
            });
        case actions.STORE_CP_READ_CATEGORIES_ERROR:
            return setErrorReducer(state, 'readCategoryListState');

        case actions.STORE_CP_CREATE_CATEGORY_REQUEST:
            return setRequestReducer(state, 'createCategoryState');
        case actions.STORE_CP_CREATE_CATEGORY_SUCCESS:
            return setSuccessReducer(state, 'createCategoryState', {
                createCategoryResult: action.createCategoryResult,
            });
        case actions.STORE_CP_CREATE_CATEGORY_ERROR:
            return setErrorReducer(state, 'createCategoryState');

        case actions.STORE_CP_READ_CATEGORY_REQUEST:
            return setRequestReducer(state, 'readCategoryState');
        case actions.STORE_CP_READ_CATEGORY_SUCCESS:
            return setSuccessReducer(state, 'readCategoryState', {
                category: action.category,
                selectedItems: action.category.items,
            });
        case actions.STORE_CP_READ_CATEGORY_ERROR:
            return setErrorReducer(state, 'readCategoryState');

        case actions.STORE_CP_UPDATE_CATEGORY_REQUEST:
            return setRequestReducer(state, 'updateCategoryState');
        case actions.STORE_CP_UPDATE_CATEGORY_SUCCESS:
            return setSuccessReducer(state, 'updateCategoryState', {});
        case actions.STORE_CP_UPDATE_CATEGORY_ERROR:
            return setErrorReducer(state, 'updateCategoryState');

        case actions.STORE_CP_UPDATE_CATEGORY_FEATURED_REQUEST:
            return setRequestReducer(state, 'updateCategoryFeaturedState');
        case actions.STORE_CP_UPDATE_CATEGORY_FEATURED_SUCCESS:
            return setSuccessReducer(state, 'updateCategoryFeaturedState', {});
        case actions.STORE_CP_UPDATE_CATEGORY_FEATURED_ERROR:
            return setErrorReducer(state, 'updateCategoryFeaturedState');

        case actions.STORE_CP_UPDATE_CATEGORY_HIDDEN_REQUEST:
            return setRequestReducer(state, 'updateCategoryHiddenState');
        case actions.STORE_CP_UPDATE_CATEGORY_HIDDEN_SUCCESS:
            return setSuccessReducer(state, 'updateCategoryHiddenState', {});
        case actions.STORE_CP_UPDATE_CATEGORY_HIDDEN_ERROR:
            return setErrorReducer(state, 'updateCategoryHiddenState');

        case actions.STORE_CP_DELETE_CATEGORY_REQUEST:
            return setRequestReducer(state, 'deleteCategoryState');
        case actions.STORE_CP_DELETE_CATEGORY_SUCCESS:
            return setSuccessReducer(state, 'deleteCategoryState', {});
        case actions.STORE_CP_DELETE_CATEGORY_ERROR:
            return setErrorReducer(state, 'deleteCategoryState');

        // Coupons
        case actions.STORE_CP_READ_COUPON_LIST_REQUEST:
            return setRequestReducer(state, 'readCouponListState');
        case actions.STORE_CP_READ_COUPON_LIST_SUCCESS:
            return setSuccessReducer(state, 'readCouponListState', {
                coupons: action.coupons,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });
        case actions.STORE_CP_READ_COUPON_LIST_ERROR:
            return setErrorReducer(state, 'readCouponListState');
        case actions.STORE_CP_CREATE_COUPON_REQUEST:
            return setRequestReducer(state, 'createCouponState');
        case actions.STORE_CP_CREATE_COUPON_SUCCESS:
            return setSuccessReducer(state, 'createCouponState', {
                createCouponResult: action.createCouponResult,
            });
        case actions.STORE_CP_CREATE_COUPON_ERROR:
            return setErrorReducer(state, 'createCouponState');
        case actions.STORE_CP_READ_COUPON_REQUEST:
            return setRequestReducer(state, 'readCouponState');
        case actions.STORE_CP_READ_COUPON_SUCCESS:
            return setSuccessReducer(state, 'readCouponState', {
                coupon: action.coupon,
            });
        case actions.STORE_CP_READ_COUPON_ERROR:
            return setErrorReducer(state, 'readCouponState');
        case actions.STORE_CP_UPDATE_COUPON_REQUEST:
            return setRequestReducer(state, 'updateCouponState');
        case actions.STORE_CP_UPDATE_COUPON_SUCCESS:
            return setSuccessReducer(state, 'updateCouponState', {});
        case actions.STORE_CP_UPDATE_COUPON_ERROR:
            return setErrorReducer(state, 'updateCouponState');
        case actions.STORE_CP_DELETE_COUPON_REQUEST:
            return setRequestReducer(state, 'deleteCouponState');
        case actions.STORE_CP_DELETE_COUPON_SUCCESS:
            return setSuccessReducer(state, 'deleteCouponState', {});
        case actions.STORE_CP_DELETE_COUPON_ERROR:
            return setErrorReducer(state, 'deleteCouponState');

        case actions.STORE_CP_INIT_CATEGORY:
            return {
                ...state,
                category: action.category,
                selectedItems: action.category.items || [],
            };
        case actions.STORE_CP_INIT_COUPON:
            return {
                ...state,
                coupon: action.coupon,
            };
        case actions.STORE_CP_SET_SELECTED_ITEMS:
            return {
                ...state,
                selectedItems: action.selectedItems || [],
            };

        case actions.STORE_CP_SET_PRODUCT_FEATURED:
        case actions.STORE_CP_SET_PRODUCT_HIDDEN:
            selectedItems = [...state.selectedItems];
            idx = selectedItems.findIndex(p => p.product_id === action.id);
            if (idx >= 0) {
                selectedItems[idx] = {...selectedItems[idx], [action.key]: action.value};
                if (action.key === 'is_hidden' && action.value === true)
                    selectedItems[idx].is_featured = false;
            }
            return {
                ...state,
                selectedItems,
            };

        case actions.STORE_CP_REARRANGE_CATEGORY:
            return {
                ...state,
                categories: arrayMove(state.categories, action.oldIndex, action.newIndex),
            };
        case actions.STORE_CP_UPDATE_CATEGORY_POSITION_REQUEST:
            return setRequestReducer(state, 'updateCategoryPositionState');
        case actions.STORE_CP_UPDATE_CATEGORY_POSITION_SUCCESS:
            return setSuccessReducer(state, 'updateCategoryPositionState');
        case actions.STORE_CP_UPDATE_CATEGORY_POSITION_ERROR:
            return setErrorReducer(state, 'updateCategoryPositionState');

        // CONTENT PAGE
        case actions.STORE_CP_READ_PAGE_LIST_REQUEST:
            return setRequestReducer(state, 'readPageListState');
        case actions.STORE_CP_READ_PAGE_LIST_SUCCESS:
            return setSuccessReducer(state, 'readPageListState', {
                pages: action.pages,
            });
        case actions.STORE_CP_READ_PAGE_LIST_ERROR:
            return setErrorReducer(state, 'readPageListState');

        case actions.STORE_CP_CREATE_PAGE_REQUEST:
            return setRequestReducer(state, 'createPageState');
        case actions.STORE_CP_CREATE_PAGE_SUCCESS:
            return setSuccessReducer(state, 'createPageState', {
                createPageResult: action.createPageResult,
            });
        case actions.STORE_CP_CREATE_PAGE_ERROR:
            return setErrorReducer(state, 'createPageState');

        case actions.STORE_CP_READ_PAGE_REQUEST:
            return setRequestReducer(state, 'readPageState');
        case actions.STORE_CP_READ_PAGE_SUCCESS:
            return setSuccessReducer(state, 'readPageState', {
                page: action.page,
            });
        case actions.STORE_CP_READ_PAGE_ERROR:
            return setErrorReducer(state, 'readPageState');

        case actions.STORE_CP_UPDATE_PAGE_REQUEST:
            return setRequestReducer(state, 'updatePageState');
        case actions.STORE_CP_UPDATE_PAGE_SUCCESS:
            return setSuccessReducer(state, 'updatePageState', {});
        case actions.STORE_CP_UPDATE_PAGE_ERROR:
            return setErrorReducer(state, 'updatePageState');

        case actions.STORE_CP_DELETE_PAGE_REQUEST:
            return setRequestReducer(state, 'deletePageState');
        case actions.STORE_CP_DELETE_PAGE_SUCCESS:
            return setSuccessReducer(state, 'deletePageState', {});
        case actions.STORE_CP_DELETE_PAGE_ERROR:
            return setErrorReducer(state, 'deletePageState');

        case actions.STORE_CP_RESET_ALL:
            return {...initState};
        default:
            return state;
    }
}
